import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AuthorizeService } from './authorize.service';
import { catchError, mergeMap, take } from 'rxjs/operators';
import { SessionContext } from 'src/app/shared/model/session-context.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeInterceptor implements HttpInterceptor {
  constructor(private authorize: AuthorizeService,
    private session: SessionContext,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authorize.getAccessToken().pipe(
      take(1),
      mergeMap((token) => this.processRequestWithToken(token, req, next))
    );
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string, req: HttpRequest<any>, next: HttpHandler) {

    var ctx = "";

    if (this.session?.BranchUId) ctx = ctx + "b=" + this.session?.BranchUId + ":";
    if (this.session?.Employee?.UID) ctx = ctx + "e=" + this.session?.Employee.UID + ":";
    if (this.session?.TerminalId) ctx = ctx + "t=" + this.session?.TerminalId + ":";

    var d = new Date();
    var timeZoneOffset = d.getTimezoneOffset();
    ctx = ctx + "TZ=" + timeZoneOffset + ":";

    if (!!token && this.isSameOriginUrl(req)) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,

          // Add custom Context header to http requests that need auth
          CTX: ctx,
        }
      });
    }

    // return next.handle(req);
    return next.handle(req).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      //navigate /delete cookies or whatever
      this.router.navigateByUrl("/Identity/Account/Login?returnUrl=checkin");
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }
}
